import React from 'react'

function TitleCase(e) {
    e.target.value = e.target.value.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
}

export default TitleCase